// import React, { useEffect, useState } from "react";

// const ThemeToggleSwitch = () => {
//   const [isDark, setIsDark] = useState(false);

//   useEffect(() => {
//     const savedTheme = localStorage.getItem("theme");
//     if (savedTheme === "dark") {
//       setIsDark(true);
//       document.body.setAttribute("data-theme-version", "dark");
//     } else {
//       setIsDark(false);
//       document.body.setAttribute("data-theme-version", "light");
//     }
//   }, []);

//   const handleToggle = () => {
//     setIsDark((prev) => {
//       const newTheme = !prev;
//       if (newTheme) {
//         document.body.setAttribute("data-theme-version", "dark");
//         localStorage.setItem("theme", "dark");
//       } else {
//         document.body.setAttribute("data-theme-version", "light");
//         localStorage.setItem("theme", "light");
//       }
//       return newTheme;
//     });
//   };

//   return (
//     <div
//       className="nav-item d-flex align-items-center"
//       style={{ cursor: "pointer" }}
//       onClick={handleToggle}>
//       <div
//         style={{
//           backgroundColor: isDark ? "#343a40" : "#f8f9fa",
//           borderRadius: "30px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: isDark ? "flex-end" : "flex-start",
//           padding: "3px",
//           transition: "all 0.3s ease-in-out",
//           boxShadow: "inset 0 0 4px rgba(0,0,0,0.1)",
//         }}>
//         <div
//           style={{
//             width: "30px",
//             height: "30px",
//             borderRadius: "50%",
//             backgroundColor: isDark ? "#f4f0ff" : "#362465",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             transition: "all 0.3s ease-in-out",
//           }}>
//           {isDark ? (
//             // Moon SVG
//             <i class="bi bi-sun text-#362465 fs-3"></i>
//           ) : (
//             <i class="bi bi-moon text-white fs-4"></i>
//             // Sun SVG
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ThemeToggleSwitch;

import React, { useEffect, useState } from "react";

const ThemeToggleSwitch = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Check existing theme on mount
    const currentTheme = document.body.getAttribute("data-theme-version");
    setIsDark(currentTheme === "dark");
  }, []);

  const handleToggle = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    document.body.setAttribute(
      "data-theme-version",
      newTheme ? "dark" : "light"
    );

    // You can remove these two lines below if you don't want localStorage
    localStorage.setItem("theme", newTheme ? "dark" : "light");
  };

  return (
    <div
      onClick={handleToggle}
      className="d-flex align-items-center gap-2"
      style={{ cursor: "pointer" }}>
      {/* Toggle Switch */}
      <div
        style={{
          backgroundColor: isDark ? "#343a40" : "#f8f9fa",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: isDark ? "flex-end" : "flex-start",
          // padding: "3px",
          transition: "all 0.3s ease-in-out",
          // boxShadow: "inset 0 0 4px rgba(0,0,0,0.1)",
        }} className="me-1">
        <div
          style={{
            width: "18px",
            height: "18px",
            borderRadius: "50%",
            backgroundColor: isDark ? "#f4f0ff" : "#362465",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.3s ease-in-out",
          }}>
          {isDark ? (
            // Sun SVG
            <i class="bi bi-sun text-#362465 fs-6"></i>
          ) : (
            <i class="bi bi-moon text-white fs-12"></i>
            // Monn SVG
          )}
        </div>
      </div>
      {/* Label */}
      <span
        style={{
          fontSize: "12.25px",
          color: isDark ? "#F9FAFB" : "",
          flex: 1,
        }}>
        {isDark ? "Dark Theme" : "Light Theme"}
      </span>
    </div>
  );
};

export default ThemeToggleSwitch;
